import classNames from 'classnames';
import React from 'react';
const Checkbox = (props) => {
    return (React.createElement("div", { className: classNames('checkbox', props.blockClassName, { disabled: props.disabled }) },
        React.createElement("div", { className: "checkbox__field" },
            React.createElement("input", { name: props.name, type: props.type, id: props.id, className: classNames('form-checkbox', props.className), "aria-required": props.required, value: props.value, onChange: (e) => {
                    props.onChange && props.onChange(e);
                }, onFocus: (e) => {
                    props.onFocus && props.onFocus(e);
                }, onBlur: (e) => {
                    props.onBlur && props.onBlur(e);
                }, checked: props.checked, disabled: props.disabled }),
            React.createElement("label", { tabIndex: -1, "aria-hidden": props.labelAriaHidden, className: classNames('form-group__label', props.labelClassName), htmlFor: props.id }, props.children))));
};
Checkbox.defaultProps = {
    type: 'checkbox',
};
export default Checkbox;
